import { get, post } from './client';

export interface ParcelLabCredentials {
  account_id?: string;
  api_token?: string;
  base_url?: string;
  clear_credentials?: boolean;
}

export interface ParcelLabConnectionStatus {
  parcellab_configured: boolean;
  parcellab_account_id: string | null;
  parcellab_base_url: string | null;
  parcellab_last_synced_at: string | null;
}

export async function updateParcelLabCredentials(
  teamId: string,
  credentials: ParcelLabCredentials,
): Promise<ParcelLabConnectionStatus> {
  return post<ParcelLabConnectionStatus>(
    `/api/teams/${teamId}/parcellab/credentials`,
    credentials,
  );
}

export async function testParcelLabConnection(
  teamId: string,
): Promise<{ status: string; connected: boolean; read_orders: boolean }> {
  return get(`/api/teams/${teamId}/parcellab/test`);
}
